import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Suppress harmless ResizeObserver errors in development
const resizeObserverError = /ResizeObserver loop completed with undelivered notifications/;
const originalConsoleError = console.error;

// In production, suppress console output entirely for security
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = (...args) => {
    // Only suppress ResizeObserver errors, log critical errors
    if (typeof args[0] === 'string' && resizeObserverError.test(args[0])) {
      return;
    }
    // Could send to error monitoring service here
  };
} else {
  console.error = (...args) => {
    if (typeof args[0] === 'string' && resizeObserverError.test(args[0])) {
      return;
    }
    originalConsoleError(...args);
  };
}

window.addEventListener('error', (e) => {
  if (resizeObserverError.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
